import { useMutation } from '@tanstack/react-query';

import { CreateUpdateLocationRequest, getSMPBackendAPIAdmin } from '@/proxy';

function createLocation(location: CreateUpdateLocationRequest) {
  return getSMPBackendAPIAdmin().locationsControllerCreateV1(location);
}

export function useCreateLocation() {
  return useMutation({ mutationFn: createLocation });
}
